import { render, staticRenderFns } from "./SettingsPasswordDialog.vue?vue&type=template&id=e8b6b170&scoped=true"
import script from "./SettingsPasswordDialog.vue?vue&type=script&lang=js"
export * from "./SettingsPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingsPasswordDialog.vue?vue&type=style&index=0&id=e8b6b170&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b6b170",
  null
  
)

export default component.exports